import {RuleBundleModel} from '../../../../../../models/api/ruleBundleModel';
import {PartialRuleModelStrict, RuleModelStrict} from '../../../../../../models/api/ruleModel';
import {buildCompoundConditions} from '../../../../../editors/conditions/compoundConditionModel';
import {initialCsatState, partialCsatDelayToDelayParameter} from '../../../../csatRuleHelpers';
import {CsatEditorSpecificState, CsatTagsModels} from './csatEditorState';

/*
 * Type.
 */

interface CsatEditorInitialState {
  rule: PartialRuleModelStrict | undefined;
  csatSpecificState: CsatEditorSpecificState;
}

/*
 * Initial state.
 */

export function createInitialCsatState(
  initialBundle: RuleBundleModel | undefined,
  csatTags: CsatTagsModels,
): CsatEditorInitialState {
  if (!initialBundle) {
    return fromDefault(csatTags);
  }

  return fromBundle(initialBundle, csatTags);
}

function fromDefault(csatTags: CsatTagsModels): CsatEditorInitialState {
  return {
    rule: undefined,
    csatSpecificState: {
      tags: {
        scheduled: csatTags.scheduled.id,
        sent: csatTags.sent.id,
      },
      actions: {
        scheduled: [],
        sent: [],
      },
      delaySinceTrigger: {},
    },
  };
}

function fromBundle(bundle: RuleBundleModel, csatTags: CsatTagsModels): CsatEditorInitialState {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const csatRules = bundle.rules as ReadonlyArray<RuleModelStrict>;

  const initialState = initialCsatState({csatRules, recipeName: bundle.name});

  const {csatResponse, initialRules, tags, conditions, actions, timeDelay} = initialState;
  const {sentRule, scheduledRule, unscheduleRule} = initialRules;
  const {surveyScheduled: scheduledTagId = csatTags.scheduled.id, surveySent: sentTagId = csatTags.sent.id} =
    tags;
  const {surveyScheduled: scheduledActions, surveySent: sentActions} = actions;

  return {
    rule: {
      id: bundle.id,
      active: sentRule.active,
      name: bundle.name,
      compoundConditions: buildCompoundConditions(conditions),
      bundle,
      namespace: bundle.namespace,
    },
    csatSpecificState: {
      actions: {scheduled: scheduledActions, sent: sentActions},
      delaySinceTrigger: {delay: partialCsatDelayToDelayParameter(timeDelay.delay)},
      tags: {sent: sentTagId, scheduled: scheduledTagId},
      response: csatResponse,
      initialRules: {
        sentRule,
        scheduledRule,
        unscheduleRule,
        bundle,
      },
    },
  };
}
